import { defineMessages } from 'react-intl';

export default defineMessages({
    removeInfo: {
        id: 'quoteandbind.PPRLinedirectives.templates.PersonalUmbrella.Remove Watercraf',
        defaultMessage: 'Remove Watercraft',
    },
    removeInfoDesc: {
        id: 'quoteandbind.PPRLinedirectives.templates.PersonalUmbrella.Watercraft',
        defaultMessage: 'Are you sure you want to remove this Watercraft from the list?',
    }
});